import React, { FC } from 'react';
import { VolunteerModel } from '../../../../shared/volunteer';
import { Fetcher, isResourceError, useFetcher } from '../../../utils';
import {
  VolunteerFormComponent,
  VolunteerFormUser,
  VolunteerLoadError,
} from '../../apply/volunteer/VolunteerForm';

interface TabDetailsProps {
  readonly user: VolunteerFormUser;
}

export const UserVolunteerTab: FC<TabDetailsProps> = ({ user }) => {
  const fetcher = useFetcher(async () => {
    let volunteer: VolunteerModel | undefined;

    try {
      volunteer = await api.getUserVolunteer(user.id);
    } catch (error) {
      if (!isResourceError(error)) {
        throw error;
      }
    }

    const form = await api.getVolunteerForm();

    return {
      form,
      volunteer,
    };
  });

  if (fetcher.error) {
    return <VolunteerLoadError error={fetcher.error} />;
  }

  if (!fetcher.data) {
    return <Fetcher result={fetcher} />;
  }

  return (
    <VolunteerFormComponent
      callback={fetcher.refresh}
      form={fetcher.data.form}
      initialVolunteer={fetcher.data.volunteer}
      user={user}
    />
  );
};
